{
    "copy_successful": "Copied to clipboard.",
    "copy_failed": "Unable to copy to clipboard."
}
